import {Component, OnInit, Input, ViewChild} from '@angular/core';
import {MatAccordion} from "@angular/material/expansion";

@Component({
  selector: 'app-accordion-help',
  templateUrl: './accordion-help.component.html',
  styleUrls: ['./accordion-help.component.css']
})
export class AccordionHelpComponent implements OnInit {

  // https://stackoverflow.com/questions/52167236/angular-6-material-design-accordion-openall

  @ViewChild('firstAccordion') firstAccordion: MatAccordion;
  @Input() helps: string[] = [];
  is_open=false;

  constructor() { }

  ngOnInit(): void {
  }

  accClosed(){
    this.is_open = false;
    console.log('closed')
  }

  accOpened(){
    this.is_open = true;
    console.log('opened')
  }

}
